import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';
import matter from 'gray-matter'; // MODIFICATION: Import the gray-matter library
import InterplayEffectAnimation from './InterplayEffectAnimation'; 

const MarkdownContent = ({ file }) => {
    const [content, setContent] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        fetch(`/content/${file}`)
            .then(response => response.text())
            .then(text => {
                // MODIFICATION: Use gray-matter to parse the file
                // This separates the metadata (data) from the actual content
                const { content } = matter(text); 
                setContent(content); // Set state with only the body content
                setIsLoading(false);
            })
            .catch(error => {
                console.error("Error fetching markdown:", error);
                setContent('Failed to load content.');
                setIsLoading(false);
            });
    }, [file]);

    if (isLoading) {
        return <div className="text-center p-8">Loading...</div>;
    }

    return (
        <div className="prose dark:prose-invert max-w-none lg:prose-lg">
            <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                remarkPlugins={[remarkBreaks]}
                components={{
                    div: ({node, ...props}) => {
                        if (props.id === 'interplay-animation') {
                            return <InterplayEffectAnimation />;
                        }
                        return <div {...props} />;
                    }
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};

export default MarkdownContent;